// represents an operator between boolean types
// ex: true and false, false or true, true XOR true
// note: when we more to binary expression trees, this enum should be expanded to include all binary operators that would return a boolean (=,!=, contains, etc)
export enum BinaryOperatorEnum {
  And,
  Or,
  XOR,
}
